import { useMemo } from 'react';

import type { Shop } from '@/types/appointment';
import type { Cart } from '@/types/booking';
import type { BnplMethodType } from '@/utils/bnpl';

import { useLaunchDarklyFlag } from '../flags/useLaunchDarklyFlag';
import { usePaymentSessionQuery } from '../queries/bnpl/usePaymentSessionQuery';
import type { BnplPaymentMethodAvailability } from '../queries/bnpl/usePaymentSessionQuery';

type UseBnplEligibilityResult = {
  isEligible: boolean;
  eligibleMethods: BnplMethodType[];
};

export const useBnplEligibility = (
  cart: Cart | null | undefined,
  _shop: Shop | null | undefined,
): UseBnplEligibilityResult => {
  const bnplExpo = useLaunchDarklyFlag('bnpl-expo', false);

  const { data: paymentSession } = usePaymentSessionQuery({
    cartId: cart?.id,
    enabled: bnplExpo,
  });

  const eligibleMethods = useMemo((): BnplMethodType[] => {
    if (!paymentSession) return [];

    const bnplEntry = paymentSession.availablePaymentMethods.find(
      (m): m is BnplPaymentMethodAvailability => m.type === 'bnpl',
    );

    return bnplEntry?.eligible ? bnplEntry.providers : [];
  }, [paymentSession]);

  return { isEligible: eligibleMethods.length > 0, eligibleMethods };
};
